import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import type { CategoryCarouselSectionProps } from 'src/components/sections/CategoryCarouselSection/CategoryCarouselSection';
import type { ValidationError } from 'src/content/types';
import type { SectionRenderer } from 'src/types/Section';
import type { Transformer } from 'src/types/Transformer';
import { lazyLoadImages } from 'src/utils/images';
import type { PageCarouselSectionContent } from './type';

export const renderer: SectionRenderer<CategoryCarouselSectionProps> =
  dynamic<CategoryCarouselSectionProps>(() =>
    import('src/components/sections/CategoryCarouselSection/CategoryCarouselSection').then(
      (mod) => mod.CategoryCarouselSection,
    ),
  );

export const transformer: Transformer<PageCarouselSectionContent, CategoryCarouselSectionProps> = (
  { _metadata, carousel_title, pages, tracking_title },
  { positionMetadata },
) => {
  const errors: ValidationError[] = [];
  const pagesToRender = (pages || []).filter((page) => {
    const hasReferencedPageFields = page.page_reference[0].title && page.page_reference[0].url;

    if (!hasReferencedPageFields) {
      errors.push({
        message: `Missing referenced page fields for (uid: ${page._metadata.uid}). Check that this page is published.`,
      });
    }

    return hasReferencedPageFields;
  });

  return {
    uid: _metadata.uid,
    props: {
      categories: pagesToRender.map((page) => {
        const referencedPage = page.page_reference[0]!;

        return {
          categoryName: page?.page_title_override || referencedPage?.title || '',
          categoryHref: referencedPage?.url || '',
          images: referencedPage?.canonical_image?.url
            ? getContentstackImagesForWidths(referencedPage.canonical_image.url, [229, 350], {
                aspectRatio: '1:1',
              })
            : [],
          imageWidth: 228,
          imageHeight: 228,
        };
      }),
      lazyImages: lazyLoadImages(positionMetadata.position),
      title: carousel_title,
      trackingTitle: tracking_title,
    },
    errors,
  };
};
